module.exports = __webpack_public_path__ + "img/saoTomeAndPrincipe.a767819c.jpg";